import React from "react";
import "./about.css";

const AboutDescription = () => {
  return (
    <div className="about_description_container">
      <p>
        In Iunie 2012, doi specialisti in sisteme de securitate cu o experienta
        de peste 10 ani in domeniu, angajati la companii de top pe piata, au pus
        bazele firmei Elitseco SRL. Unsprezece ani mai tarziu ne putem lauda cu
        peste o mie de proiecte finalizate cu succes.
      </p>
      <p>
        Impreuna cu o echipa compatibila 100% cu valorile si etica firmei, am
        accesat numeroase proiecte de referinta.Tehnicienii si inginerii nostri
        participa periodic la cursuri si conferinte pentru a putea fi mereu la
        curent cu noutatile pietei.
      </p>
      <p>
        Pornind de la solutii in sisteme de supraveghere video, detectie si
        avertizare incediu, interfonie, automatizari usi si porti, sisteme de
        acces cu turnicheti la servicii de proiectare, instalare, mentenanta si
        service, Elitseco SRL este mereu aproape de clientii sai.
      </p>
    </div>
  );
};

export default AboutDescription;
